module.exports = __webpack_public_path__ + "static/media/hiper.a385dd21.png";